'use strict';

import { scrollIntoView } from 'seamless-scroll-polyfill';

// const bodyScrollLock = require('body-scroll-lock');
// const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;

document.addEventListener(
  'DOMContentLoaded',
  function() {
    const navBp: number = 992;
    const nav: any = document.querySelector('#js-nav');
    const toggleBtn = nav.querySelector('.js-toggle-nav');
    const mainNavList = nav.querySelector('.nav__list--level-1');
    const navDropdownLinks = nav.querySelectorAll('a[data-dropdown="true"]');
    const navLinksAll = nav.querySelectorAll('a, button');
    const mobileNavMenu = nav.querySelector('.js-mobile-nav');
    const navItems = [].slice.call(document.querySelectorAll('.nav__link'));

    if (!nav) {
      return;
    }

    /* -----------
    * Functions
    ----------- */

    /* --- Toggle mobile nav open and closed --- */
    function toggleNav() {
      if (nav.classList.contains('open')) {
        // close
        closeMobileNav();
      } else {
        // open
        const bodyRect: any = document.body.getBoundingClientRect();
        const navRect: any = nav.getBoundingClientRect();
        const topOfNav: number = navRect.top - bodyRect.top;

        const windowPosition: number = window.scrollY || window.pageYOffset;

        if (windowPosition !== topOfNav) {
          // scroll to top of nav before opening
          scrollIntoView(nav, { behavior: 'smooth' });
          setTimeout(function() {
            nav.classList.add('open');
            // disableBodyScroll(document.querySelector('.nav__menu-container'));
            const body: any = document.querySelector('body');
            if (body) {
              body.style.overflow = 'hidden';
            }
            closeSubMenus();
          }, 500);
        } else {
          const body: any = document.querySelector('body');
          if (body) {
            body.style.overflow = 'hidden';
          }
          nav.classList.add('open');
        }
      }
    }

    /* --- Close mobile nav --- */
    function closeMobileNav() {
      nav.classList.remove('open');
      // clearAllBodyScrollLocks();
      const body: any = document.querySelector('body');
      if (body) {
        body.style.overflow = null;
      }

      // reset any sub menus that were opened
      setTimeout(function() {
        closeSubMenus();
      }, 300); // set the time to be the same as the css animation to close the nav
    }

    /* --- Close submenus if focusing on a different nav link --- */
    function closeSubMenusOnFocus() {
      const openDropdown = document.querySelector('.nav__dropdown.open');
      const linkInDropdown = openDropdown && openDropdown.contains(this) ? true : false;
      if (!this.classList.contains('open') && !linkInDropdown) {
        closeSubMenus();
      }
    }

    /* --- Open the submenu for the selected link (mobile & desktop) --- */
    function openSubMenu(e) {
      if (window.matchMedia(`(min-width: ${navBp}px)`).matches || (window.matchMedia(`(max-width: ${navBp-1}px)`).matches && !e.target.classList.contains('open'))) {
        closeSubMenus(); // close all open sub menus first
      }
      const link = e.target;

      if ((e.type === 'mouseover' && window.matchMedia(`(min-width: ${navBp}px)`).matches) || e.type === 'click') {
        const dropdown = link.nextElementSibling;

        link.classList.toggle('open');
        mobileNavMenu.classList.add('sub-menu-open');
        dropdown.classList.add('open');
        dropdown.setAttribute('aria-hidden', false);
      }
    }

    /* --- Close the open submenus (mobile & desktop) --- */
    function closeSubMenus() {
      const links = nav.querySelectorAll('.nav__link.open');
      const dropdowns = nav.querySelectorAll('.nav__dropdown.open');

      mobileNavMenu?.classList.remove('sub-menu-open');

      links.forEach((link) => {
        link.classList.remove('open');
      });
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove('open');
        dropdown.setAttribute('aria-hidden', true);
      });
    }

    /* --- Toggle sub menus open and closed (mobile & desktop) --- */
    function toggleSubMenu(e) {
      e.preventDefault();

      if (!this.classList.contains('open')) {
        openSubMenu(e);
      } else {
        closeSubMenus();
      }
    }

    /* Event listeners */
    toggleBtn?.addEventListener('click', toggleNav); // mobile nav toggle menu button

    navDropdownLinks.forEach((dropdownLink) => {
      // links that have dropdowns
      dropdownLink.addEventListener('click', toggleSubMenu);
      dropdownLink.addEventListener('mouseover', openSubMenu);
    });

    navLinksAll.forEach((link) => {
      // all links in the nav
      link.addEventListener('focusin', closeSubMenusOnFocus);
    });

    navItems.forEach(function(link) {
      link.addEventListener('click', function() {
        // close mobile nav when clicking on anchor links
        if (window.location.pathname === '/'
            && link.getAttribute('data-dropdown') !== 'true'
            && (link.getAttribute('href').startsWith('#') || link.getAttribute('href').startsWith('/#'))
        ) {
          closeMobileNav();
        }
      });
    });

    window.addEventListener('mouseover', (e) => {
      if (mainNavList && !mainNavList.contains(e.target) && window.matchMedia(`(min-width: ${navBp}px)`).matches) {
        closeSubMenus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia(`(min-width: ${navBp}px)`).matches) {
        closeMobileNav();
        // reset any sub menus that were opened
        closeSubMenus();
      }
    });

    /* --- Sticky nav, showing on scroll up (mobile & desktop) --- */
    //  if (nav.classList.contains('--absolute')) {
    // let previousPosition = -1;

    window.addEventListener('scroll', () => {
      const windowPosition = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;
      //   let startPosition: number = 0;

      //   if (window.matchMedia(`(min-width: ${navBp}px)`).matches) {
      // 	 startPosition += nav.getBoundingClientRect().height - mobileNavMenu.getBoundingClientRect().height;
      //   }

      if (windowPosition > windowHeight) {
        nav.classList.add('fixed');
        nav.classList.add('show');

        //  nav.classList.remove('top');

        //  if (windowPosition < previousPosition) {
        // 	nav.classList.add('show');
        // 	document.body.classList.add('body--nav-sticky');
        //  } else {
        // 	nav.classList.remove('show');
        // 	document.body.classList.remove('body--nav-sticky');
        //  }
        //   } else if (windowPosition <= startPosition) {
        // 	 nav.classList.remove('show');
        // 	 document.body.classList.remove('nav-sticky');
        // 	 nav.classList.remove('fixed');
        // 	 nav.classList.remove('top');
        //   } else if (windowPosition < windowHeight) {
        // 	 nav.classList.add('top');
        /* ---Nav flickering bug fix wait 50px until doing the else--- */
      } else if (windowPosition < windowHeight - 50) {
        nav.classList.remove('fixed');
        nav.classList.remove('show');
      }
      //   previousPosition = windowPosition;
    });
    //  }
  }
);
